/* BAZ interactions: reveal, face finder, tabs, spotlight switcher, quick add. Only transform/opacity are animated. */
(() => {
  if (window.__bazInit) return;
  window.__bazInit = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initReveal = (root) => {
    let els = root.querySelectorAll('[data-baz-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    /* anything already on screen stays visible (no blank flash); only content below the fold animates in */
    const vh0 = window.innerHeight;
    els.forEach((e) => { const r = e.getBoundingClientRect(); if (r.top < vh0 && r.bottom > 0) e.classList.add('is-in'); else e.classList.add('baz-pre'); });
    els = root.querySelectorAll('[data-baz-reveal]:not(.is-in)');
    if (!els.length) return;
    const show = (e) => { e.classList.add('is-in'); io.unobserve(e); };
    const io = new IntersectionObserver((entries) => entries.forEach((en) => { if (en.isIntersecting) show(en.target); }), { threshold: 0.01, rootMargin: '0px 0px -5% 0px' });
    const sweep = () => { const h = window.innerHeight; root.querySelectorAll('[data-baz-reveal]:not(.is-in)').forEach((e) => { const r = e.getBoundingClientRect(); if (r.top < h && r.bottom > 0) show(e); }); };
    document.addEventListener('scroll', () => requestAnimationFrame(sweep), { passive: true, capture: true });
    setTimeout(sweep, 400);
    setTimeout(() => root.querySelectorAll('[data-baz-reveal]:not(.is-in)').forEach((e) => e.classList.add('is-in')), 4000);
    els.forEach((e) => { if (!e.style.getPropertyValue('--i')) { const sib = [...e.parentElement.children].filter((c) => c.hasAttribute('data-baz-reveal')); e.style.setProperty('--i', Math.min(sib.indexOf(e), 6)); } io.observe(e); });
  };

  const crossfade = (el) => { if (!reduce && el) el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-out' }); };

  /* face finder: radios swap result panels in place */
  const initFinder = (el) => {
    if (el.dataset.bazReady) return; el.dataset.bazReady = '1';
    const radios = el.querySelectorAll('input[type=radio]'); const panels = el.querySelectorAll('[data-baz-panel]');
    const show = (id) => panels.forEach((p) => { const on = p.dataset.bazPanel === id; p.hidden = !on; if (on) crossfade(p); });
    radios.forEach((r) => r.addEventListener('change', () => show(r.value)));
    const checked = el.querySelector('input:checked'); if (checked) show(checked.value);
  };

  /* tabs (best sellers) */
  const initTabs = (el) => {
    if (el.dataset.bazReady) return; el.dataset.bazReady = '1';
    const tabs = [...el.querySelectorAll('[data-baz-tab]')]; const panels = [...el.querySelectorAll('[data-baz-tabpanel]')];
    tabs.forEach((t) => t.addEventListener('click', () => {
      tabs.forEach((x) => { const on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
      panels.forEach((p) => { const on = p.dataset.bazTabpanel === t.dataset.bazTab; p.hidden = !on; if (on) crossfade(p); });
    }));
  };

  /* spotlight: tiles swap image, name, price, EMI, saving, tint */
  const initSpot = (el) => {
    if (el.dataset.bazReady) return; el.dataset.bazReady = '1';
    const $ = (s) => el.querySelector(s); const stage = $('[data-baz-stage]'); const img = $('[data-baz-img]');
    const sw = [...el.querySelectorAll('[role=radio]')]; const add = $('[data-baz-add]'); const buy = $('[data-baz-buy]');
    const set = (b) => {
      const d = b.dataset; sw.forEach((x) => x.setAttribute('aria-checked', x === b));
      const apply = () => {
        if (img && d.img) { img.src = d.img; img.alt = d.name; }
        $('[data-baz-name]').textContent = d.name; $('[data-baz-shape]').textContent = d.shape || '';
        $('[data-baz-now]').textContent = d.price; $('[data-baz-was]').textContent = d.was || ''; $('[data-baz-save]').textContent = d.save || '';
        $('[data-baz-emi]').textContent = d.emi || '';
        const off = $('[data-baz-off]'); if (off) { off.textContent = d.off ? '-' + d.off + '%' : ''; off.hidden = !d.off; }
        if (stage) stage.style.setProperty('--stage-tint', d.tint);
        if (add) { add.dataset.id = d.variant; add.dataset.url = d.url; add.disabled = d.available !== 'true'; }
        if (buy) buy.href = d.url;
        stage?.classList.remove('is-swapping');
      };
      if (reduce || !stage) apply(); else { stage.classList.add('is-swapping'); setTimeout(apply, 175); }
    };
    sw.forEach((b) => b.addEventListener('click', () => set(b)));
    sw.forEach((b, i) => b.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { const n = sw[(i + (e.key === 'ArrowRight' ? 1 : sw.length - 1)) % sw.length]; n.focus(); set(n); } }));
  };

  /* card gallery dots */
  const initGallery = (g) => {
    if (g.dataset.bazReady) return; g.dataset.bazReady = '1';
    const dots = g.parentElement.querySelectorAll('.baz-card__dots i');
    g.addEventListener('scroll', () => { const i = Math.round(g.scrollLeft / g.clientWidth); dots.forEach((d, n) => d.classList.toggle('is-on', n === i)); }, { passive: true });
  };

  /* load more inside grid panels */
  const initMore = (btn) => {
    if (btn.dataset.bazReady) return; btn.dataset.bazReady = '1';
    const grid = btn.closest('[data-baz-tabpanel], .baz-section').querySelector('.baz-pgrid'); const step = parseInt(btn.dataset.step || '8', 10);
    const hidden = () => [...grid.querySelectorAll(':scope > [hidden]')];
    const sync = () => { btn.hidden = hidden().length === 0; };
    btn.addEventListener('click', () => { hidden().slice(0, step).forEach((c) => { c.hidden = false; c.querySelectorAll('[data-baz-reveal]').forEach((r) => r.classList.add('is-in')); }); sync(); });
    sync();
  };

  /* added-to-bag toast (keeps shoppers on the page, offers checkout) */
  let toastTimer;
  window.bazToast = (item) => {
    let t = document.querySelector('.baz-toast');
    if (!t) { t = document.createElement('div'); t.className = 'baz-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    const img = item && (item.image || (item.featured_image && item.featured_image.url));
    const name = (item && (item.product_title || item.title)) || '';
    t.innerHTML = (img ? '<img class="baz-toast__img" src="' + img + (img.includes('?') ? '&' : '?') + 'width=120" alt="">' : '') +
      '<div class="baz-toast__txt"><b>Added to bag</b><span></span></div><a class="baz-toast__view" href="/cart">View bag</a><a class="baz-toast__go" href="/checkout">Checkout</a>';
    t.querySelector('span').textContent = name;
    requestAnimationFrame(() => t.classList.add('is-on'));
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-on'), 5000);
  };


  /* colour swatches on cards: swap image, price, bag button and links */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-baz-sw]'); if (!sw) return;
    e.preventDefault();
    const card = sw.closest('.baz-card'); if (!card) return;
    card.querySelectorAll('[data-baz-sw]').forEach((b) => { const on = b === sw; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
    const d = sw.dataset;
    const gallery = card.querySelector('[data-baz-gallery]');
    if (gallery && d.pos !== '' && +d.pos >= 0) { gallery.scrollTo({ left: gallery.clientWidth * +d.pos, behavior: 'smooth' }); }
    else {
      const img = card.querySelector('.baz-card__media img');
      if (img && d.img) { img.classList.add('is-swapping'); const n = new Image(); n.onload = () => { img.removeAttribute('srcset'); img.src = d.img; img.classList.remove('is-swapping'); }; n.src = d.img; }
    }
    const pr = card.querySelector('.baz-card__price');
    if (pr) {
      const b = pr.querySelector('b'); if (b) b.textContent = d.price;
      let s = pr.querySelector('s'), em = pr.querySelector('em');
      if (d.was) { if (!s) { s = document.createElement('s'); pr.appendChild(s); } if (!em) { em = document.createElement('em'); pr.appendChild(em); } s.textContent = d.was; em.textContent = d.off; }
      else { s && s.remove(); em && em.remove(); }
    }
    const q = card.querySelector('[data-baz-add]'); if (q) { q.dataset.id = d.id; q.dataset.url = d.url; q.disabled = d.available !== 'true'; }
    card.querySelectorAll('a[href*="/products/"]').forEach((a) => { a.href = d.url; });
  });

  /* quick add: add one unit; multi-variant products open the product page */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-baz-add]'); if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (btn.dataset.multi === 'true') { window.location.href = btn.dataset.url; return; }
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: Number(btn.dataset.id), quantity: 1 }) });
      if (!res.ok) throw new Error('add failed');
      const item = await res.json().catch(() => null);
      btn.classList.add('is-done');
      fetch('/cart.js').then((r) => r.json()).then((c) => document.dispatchEvent(new CustomEvent('baz:cart-updated', { detail: { count: c.item_count } }))).catch(() => {});
      if (btn.dataset.after === 'cart') { window.location.href = '/cart'; return; }
      window.bazToast(item);
      setTimeout(() => btn.classList.remove('is-done'), 1800);
    } catch (err) { window.location.href = btn.dataset.url || '/cart'; }
    btn.disabled = false;
  });

  /* cart money: Horizon prints the store format ("Rs. 1,399.00 INR"); show it the BAZ way (₹1,399) */
  const moneyFix = (root = document) => {
    const rupee = document.documentElement.dataset.bazRupee === 'true';
    root.querySelectorAll('.cart-page, cart-drawer-component, .cart-drawer, cart-items-component').forEach((scope) => {
      const w = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      const nodes = []; while (w.nextNode()) nodes.push(w.currentNode);
      nodes.forEach((n) => {
        const t = n.nodeValue; if (!t || !/(Rs\.?|₹|INR)/.test(t)) return;
        let v = t.replace(/(Rs\.?\s?|₹\s?|INR\s?)([\d,]+)(\.00)?(\s?INR)?/g, (m, p1, num) => (rupee ? '₹' : 'Rs. ') + num);
        if (v !== t) n.nodeValue = v;
      });
    });
  };
  const moneyObserve = () => {
    const target = document.querySelector('cart-drawer-component') || document.querySelector('.cart-page');
    if (!target || target.dataset.bazMoney) return; target.dataset.bazMoney = '1';
    let t; new MutationObserver(() => { clearTimeout(t); t = setTimeout(() => moneyFix(), 60); }).observe(target, { childList: true, subtree: true, characterData: true });
  };

  /* --baz-fit: screen height left under the sticky header (and the phone tab bar), so standalone sections can fit one screen */
  const setFit = () => {
    const hg = document.querySelector('#header-group'); const tb = document.querySelector('.baz-tabbar');
    const chrome = (hg ? hg.getBoundingClientRect().height : 0) + (tb && getComputedStyle(tb).display !== 'none' ? tb.getBoundingClientRect().height : 0);
    document.documentElement.style.setProperty('--baz-fit', Math.max(420, window.innerHeight - chrome) + 'px');
  };
  setFit(); window.addEventListener('resize', () => requestAnimationFrame(setFit)); window.addEventListener('load', setFit);

  const init = (root = document) => {
    moneyFix(root); moneyObserve();
    document.body.classList.toggle('baz-no-anim', document.documentElement.dataset.bazAnim === 'off' || reduce);
    initReveal(root);
    root.querySelectorAll('[data-baz-finder]').forEach(initFinder);
    root.querySelectorAll('[data-baz-tabs]').forEach(initTabs);
    root.querySelectorAll('[data-baz-spot]').forEach(initSpot);
    root.querySelectorAll('[data-baz-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-baz-more]').forEach(initMore);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* Background videos (snippets/baz-video.liquid): loads only the desktop or mobile file for the current screen,
   plays muted while on screen (and while its slide is active), pauses otherwise, honours reduced motion. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => { e.target._inView = e.isIntersecting; sync(e.target); }), { rootMargin: '200px 0px' })
    : null;
  const gateOk = (v) => { const g = v.closest('[data-vid-gate]'); return !g || g.classList.contains('is-active'); };
  function sync(v) {
    const mob = window.matchMedia('(max-width: ' + (v.dataset.bp || 749) + 'px)').matches;
    const src = mob ? v.dataset.m : v.dataset.d;
    const poster = mob ? v.dataset.mp : v.dataset.dp;
    if (!src) {
      if (!v.hidden) { v.pause(); v.removeAttribute('src'); v._src = ''; v.load(); v.hidden = true; }
      return;
    }
    v.hidden = false;
    if (poster && v.getAttribute('poster') !== poster) v.setAttribute('poster', poster);
    const want = v._inView && gateOk(v) && !reduce.matches;
    if (want && v._src !== src) { v.src = src; v._src = src; }
    if (want) { const p = v.play(); if (p) p.catch(() => {}); } else if (!v.paused) v.pause();
  }
  function init(root) {
    (root || document).querySelectorAll('[data-baz-vid]').forEach((v) => {
      if (v._baz) return; v._baz = true; v._inView = !io;
      const card = v.closest('[data-vid-card]');
      if (card) { v.addEventListener('playing', () => card.classList.add('is-playing')); v.addEventListener('pause', () => card.classList.remove('is-playing')); }
      const g = v.closest('[data-vid-gate]');
      if (g) new MutationObserver(() => sync(v)).observe(g, { attributes: true, attributeFilter: ['class'] });
      if (io) io.observe(v);
      sync(v);
    });
  }
  const all = () => document.querySelectorAll('[data-baz-vid]').forEach(sync);
  let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(all, 150); });
  if (reduce.addEventListener) reduce.addEventListener('change', all);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
})();
